import jQuery from 'jquery';
import Backbone from 'backbone';

export default Backbone.View.extend(
  /**
   * @lends core.layers.dataProviders.base.DataProvider.prototype
   */
  {
    /**
     * @class DataProvider
     * @classdesc This is a data provider base
     * @abstract
     * @memberof core.layers.dataProviders.base 
     * @constructs
     */
    constructor() {},

    /**
     * Check visibility in order to do or not the load
     * @private
     */
    _checkVisibility() {
      //This event fires hide/show methods.
      this.zoomChangedEvent = google.maps.event.addListener(this.widget.map, 'zoom_changed', () => {
        if (this.options.model.get('active')) {
          this.options.model.set('visible', this.isAvailableZoom(this.options.minZoom));
        }
      });
    },

    /**
     * Check if the current zoom level is bigger than the minimun zoom level of layer
     * @returns {boolean} If layer will be visible on this zoom level
     */
    isAvailableZoom(zoom) {
      return this.widget.map.getZoom() >= zoom;
    },
    
    /**
     * Method to load the source data
     * @abstract
     * @returns {Promise}
     */
    load() {
      let deferred = jQuery.Deferred();
      deferred.reject('Load function must be implented');
      return deferred;
    }
  });



// WEBPACK FOOTER //
// ./lmm-widget/src/layers/dataProviders/_base/DataProvider.js